import FAQ from '@/data/faq.yml';
import ContentBlock from '@/components/newsletter/blocks/ContentBlock';
import Expander from '@/components/Expander';
import dynamicLocalization from "@/mixins/dynamic-localization"

export default {
    mixins: [dynamicLocalization],
    components: { ContentBlock, Expander },
    data() {
        return {
            FAQ
        }
    }
}
